const getElementDimensions = (ref) => {
  const { current: el } = ref;
  if (el) return { width: el.offsetWidth, height: el.offsetHeight };
  return { width: null, height: null };
};

export default getElementDimensions;
